module.exports = __webpack_public_path__ + "static/assets/85132edb4e9d52a62ceb6928de3e2084.gif";